<template>
  <div class="routing-page">
    <div class="panel">
      <routing-header></routing-header>
      <div class="tabs">
        <a v-bind:class="{ tab: true, active: activeTabIndex === 0 }" href="javascript:;"
          @click="activeTabIndex = 0">
          UNPACKAGED RESERVATIONS
        </a>
        <a v-bind:class="{ tab: true, active: activeTabIndex === 1 }" href="javascript:;"
          @click="activeTabIndex = 1">
          PACKAGES
        </a>
      </div>
      <div class="tab-contents">
        <div id="routing-reservations-table" v-bind:class="{ 'tab-content': true, active: activeTabIndex === 0 }" @scroll="onScrollUnpackage">
          <reservations-table ref="routingRsvpTable" :isMobile="isMobile"></reservations-table>
        </div>
        <div id="routing-packages-table" v-bind:class="{ 'tab-content with-control': true, active: activeTabIndex === 1 }" @scroll="onScrollPackage">
          <packages-table :forDispatch="false" ref="routingPkgTable" :isMobile="isMobile"></packages-table>
          <packages-control :forDispatch="false" class="tab-control"></packages-control>
        </div>
      </div>
    </div>
    <div class="toggle-mobile" @click="showMapMobile = !showMapMobile">
      <span v-if="!showMapMobile">Show Map <i class="fa fa-chevron-up"></i></span>
      <span v-else>Hide Map <i class="fa fa-chevron-down"></i></span>  
    </div>
    <div :class="['right-panel', showMapMobile ? 'showMapBox' : '']">
      <div class="map">
        <!-- <routing-map v-if="route === 'Routing' || route === 'Dispatch'"></routing-map> -->
        <routing-map2></routing-map2>
      </div>
      <div class="dropzone-container">
        <drop-zone></drop-zone>
      </div>
    </div>
    <routing-modal></routing-modal>
    <ready-to-go-modal></ready-to-go-modal>
    <pickup-date-modal></pickup-date-modal>
  </div>

</template>

<script>
import DropZone from './DropZone'
import PackagesControl from './PackagesControl'
import PackagesTable from './PackagesTable'
import PickupDateModal from '../Routing/PickupDateModal'
import ReservationsTable from './ReservationsTable'
import RoutingHeader from './Header'
// import RoutingMap from './Map'
import RoutingMap2 from './Map2'
import RoutingModal from './RoutingModal'
import ReadyToGoModal from '@/components/Dispatch/ReadyToGoModal'

export default {
  name: 'routing-page',
  components: {
    DropZone, PackagesControl, PackagesTable,
    ReservationsTable, RoutingHeader, RoutingMap2,
    RoutingModal, ReadyToGoModal, PickupDateModal
  },
  data () {
    return {
      activeTabIndex: 0,
      isMobile: false,
      showMapMobile: false
    }
  },
  computed: {
    route () { return this.$route.name }
  },
  methods: {
    onScrollUnpackage (event) {
      let scrollAndView = event.target.scrollTop + event.target.offsetHeight
      if (event.target.scrollHeight - scrollAndView < 150) {
        if (this.$refs.routingRsvpTable.onScroll()) { this.$refs.routingRsvpTable.onScroll() }
      }
    },
    onScrollPackage (event) {
      let scrollAndView = event.target.scrollTop + event.target.offsetHeight
      if (event.target.scrollHeight - scrollAndView < 150) {
        if (this.$refs.routingPkgTable.onScroll()) { this.$refs.routingPkgTable.onScroll() }
      }
    },
    setScreenSize() {
      let self = this
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        self.isMobile = true
      } else {
        self.isMobile = false
      }
    }
  },
  mounted() {
    this.setScreenSize()
  }
}
</script>

<style lang="scss" scoped>
$panel-width: 995px;
.panel {
  z-index: 1;
  position: fixed;
  width: #{$panel-width};
  top: 0;
  left: 0;
  height: 100%;
  box-shadow: 2px 0 8px rgba(0,0,0,0.25);
}

.right-panel {
  z-index: 0;
  position: fixed;
  top: 0;
  left: #{$panel-width};
  width: calc(100% - #{$panel-width});
  height: 100%;
  & .map {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 55%;
  }

  & .dropzone-container {
    position: absolute;
    top: 55%;
    left: 0;
    width: 100%;
    height: 45%;
    box-shadow: 0 -2px 8px rgba(0,0,0,0.25);
  }
}


.tabs {
  position: relative;
  z-index: 1;
  padding: 10px 10px 0 10px;
  & .tab {
    display: inline-block;
    background-color: rgba(255,255,255,0);
    font-size: 14px;
    font-weight: 700;
    padding: 10px 20px;
    border: 1px solid rgba(0,0,0,0.2);
    border-bottom: 0;
    text-decoration: none;
    transition: all 250ms;

    &:not(:first-child) {
    }

    &.active {
      background-color: #f5f5f5;
      pointer-events: none;
    }
  }
}

.tab-contents {
  margin-top: -1px;
  border-top: 1px solid rgba(0,0,0,0.2);
  background-color: #f5f5f5;
  position: relative;
  z-index: 0;
  width: 100%;
  height: calc(100% - 102px);

  & .tab-content {
    display: none;
    height: 100%;
    overflow: auto;
    &.active { display: block; }
    &.with-control { height: calc(100% - 80px); }
  }

  & .tab-control {
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: #fff;
    width: 100%;
    border-top: 1px solid rgba(0,0,0,0.3);
    padding: 20px 10px;
  }
}

.infinity-loader{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
  background: rgba(0,0,0, .6);
  color: #fff;
  transform-origin: bottom center;
  text-align: center;
  font-size: 18px;
  line-height: 40px;
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .3s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}

@media screen and (max-width: 430px) {
  .toggle-mobile {
    display: block;
    color: #fff;
    background-color: #333;
    cursor: pointer;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    padding: 8px 0;
    height: 50px;
    -webkit-transition: top .25s;
    transition: top .25s;
    z-index: 9;
    text-transform: uppercase;
    font-weight: 900;
  }
  .tab-contents {
    .tab-control {
      bottom: 50px;
      padding: 10px 5px;
    }
  }
  .panel {
    width: 100%;
  }
  .right-panel {
    left: 0;
    width: 100%;
    z-index: 5;
    top: 100%;
    transition: all 0.3s ease;
    background-color: #fff;
    &.showMapBox {
      top: 0;
    }
    .map {
      height: 35%;
    }
    .dropzone-container {
      top: 35%;
      height: 65%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Routing/index.vue